import { create } from 'zustand';
import { SessionKeyStore } from '../services/keyStore';

export type AuthStep =
  | 'checking'      // App startet, prüft ob Setup nötig
  | 'setup-new'     // Erster Start: Passwort festlegen
  | 'setup-confirm' // Passwort bestätigen
  | 'setup-recovery'// Recovery-Wortliste anzeigen
  | 'login'         // Normaler Login
  | 'unlocked';     // Eingeloggt, App nutzbar

interface AuthState {
  step: AuthStep;
  isSetupComplete: boolean;
  googleConnected: boolean;
  setStep: (step: AuthStep) => void;
  setSetupComplete: (v: boolean) => void;
  setGoogleConnected: (v: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  step: 'checking',
  isSetupComplete: false,
  googleConnected: false,

  setStep: (step) => { set({ step }); },
  setSetupComplete: (v) => { set({ isSetupComplete: v }); },
  setGoogleConnected: (v) => { set({ googleConnected: v }); },

  logout: () => {
    SessionKeyStore.wipe();
    set({ step: 'login' });
  },
}));
